import logoPlaceholder from '@assets/placeholders/linkthumb.jpg';

export const siteSettings = {
  currencyCode: 'CZK',
  locale: "cs-Cz",
  currencySymbol: 'Kč',
  name: 'i33 | Kênh buôn bán online của người Việt',
  description: 'Với mong muốn hiện đại hóa cách thức kinh doanh trong thời đại công nghiệp 4.0, kênh thương mại điện tử i33 đã được ra đời. Chúng tôi là cầu nối giữa các nhà sản xuất, các tổng kho đổ buôn và các cửa hàng bán lẻ trên toàn thị trường cộng hòa Séc.',
  logo: `${process.env.NEXT_PUBLIC_SHOP_URL}${logoPlaceholder?.src}`,
  googleSiteVerification: 'KaBohdJ5qle2z2ocOrV_4YqADcZpekLIIrnEs3syMvw',
  facebookDomainVerification: `${process?.env?.NEXT_PUBLIC_FACEBOOK_DOMAIN_VERIFICATION}`,
  facebookMetaPixel: `${process?.env?.NEXT_PUBLIC_FACEBOOK_META_PIXEL_ID}`

};
export const FILE_FORMATS = ["image/jpg", "image/png", "image/jpeg", "image/webp"];
